import guestHouse1 from "../../../assets/images/guest-house1.jpg";
import guestHouse2 from "../../../assets/images/guest-house2.jpg";

export const guestHouseImages = [
  {
    id: 1,
    image: guestHouse1,
  },
  {
    id: 2,
    image: guestHouse2,
  },
];
export const guestHouse = [
  "The ISKCON Prabhupada Ashrya Bhavan is a welcoming and comfortable guesthouse located on the grounds of the ISKCON Vallabh Vidya Nagar temple. With 12 guestrooms available, including 2 AC and 10 non-AC rooms, the guesthouse is an ideal place to stay for both life patrons and non-life members who are looking for a comfortable and convenient place to rest during their visit.",

  "For life members, the guesthouse offers a special rate that includes prasad, or blessed vegetarian food, as part of their stay. Non-AC life members can enjoy this exclusive benefit for only 400₹ per day, while those who prefer the comfort of an air-conditioned room can opt for the AC life member package, which includes prasad for 750₹ per day.",

  "For non-life members, the guesthouse offers affordable rates for both AC and non-AC rooms, with prices starting at 600₹ per day for non-AC rooms and 950₹ per day for AC rooms. In addition, guests can enjoy delicious vegetarian food at the Govindas Snacks Center and Restaurant, which is conveniently located on the temple grounds.",

  "The guesthouse also offers a range of amenities to ensure a comfortable and pleasant stay.These include 24-hour hot water, lifts, spacious and comfortable rooms, and extra bedding as needed. And with a check-out time of 24 hours, guests have the flexibility to depart at a time that is convenient for them, with only a half-day charge applicable for stays beyond the 24-hour period.",

  "Whether you are a life member or a non-life member, the ISKCON Prabhupada Ashrya Bhavan is a wonderful place to stay during your visit to ISKCON Vallabh Vidya Nagar. With its welcoming atmosphere, comfortable accommodations, and convenient location, it is the perfect home away from home for anyone seeking spiritual nourishment and peaceful surroundings.",

  "Contact Details:",
];

export const contactDetails = [
  {
    id: 1,
    number: "+91 02692 235752",
  },
  {
    id: 2,
    number: "+91 02692 233012",
  },
];
